/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

/**
 * Meta's Advertising Standards forbid instant-form questions that ask for
 * certain kinds of information, and Meta does not run an ad whose form has one.
 * This is a best-effort Portuguese keyword screen of Meta's published list
 * ("Perguntas proibidas no formulário instantâneo"), mirroring the backend's
 * `facebook_leadads/_question_policy.py` -- which is the one that enforces it.
 * A question that passes here can still be rejected by Meta.
 */
const PROHIBITED_QUESTION_PATTERNS: readonly RegExp[] = [
  /cartao de (credito|debito)|conta bancaria|numero (da|de) conta|\bscore\b|\brendas?\b|\bsalario|patrimonio|falencia|\bdividas?\b|\bnome sujo\b/,
  /\bcpf\b|\brg\b|\bcnh\b|carteira de motorista|passaporte|identidade|numero do documento|titulo de eleitor/,
  /antecedentes|historico criminal|ficha criminal|\bpreso\b|condenad/,
  /\bsaude\b|doenca|deficiencia|medicamento|tratamento medico|\bgravida/,
  /seguradora|apolice|plano de saude/,
  /partido|candidato|\bvoto\b|\bvotou\b|eleicao|eleicoes|politic/,
  /\braca\b|etnia|cor da pele/,
  /religia|religios|crenca|\bigreja\b/,
  /orientacao sexual|vida sexual|\bsexual\b|\bnamorar\b/,
  /sindicato|sindicalizad/,
  /\bsenha\b|\blogin\b/,
  /nascimento d[oa] (filh|crianc)|aniversario d[oa] (filh|crianc)/,
  // The form already collects these for free; Meta bans asking again.
  /\bnome\b|e-?mail|telefone|celular|whatsapp/,
];

/**
 * Whether a Lead Ad form question appears to ask for something Meta forbids.
 *
 * @param question - The extra form question as typed.
 * @returns True when Meta would likely refuse a form containing it.
 */
export function isProhibitedLeadAdQuestion(question: string): boolean {
  const text = question.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  return PROHIBITED_QUESTION_PATTERNS.some((pattern) => pattern.test(text));
}
